angular.module('app.controllers').controller 'HomeCtrl', [
  '$scope', '$rootScope', 'UI', 'APIRead', '$location'
].append (self, root, UI, APIRead, $location) ->
  
  APIRead.query {entry_type: 'campaign', limit: 100, full: true, lang: root.lang || 'es'}, (data) ->
    self.campaigns = data.filter((c) -> return c.exhibitor_id in [1269650,1269987])
  , (response) ->
    UI.notify false, response.data.error

  self.videos = [
    {
      "embed": "https://www.youtube.com/embed/PkUZyemHtKk",
      "thumbs": {
        "default": "https://img.youtube.com/vi_webp/PkUZyemHtKk/hqdefault.webp"
        "maxres": "https://img.youtube.com/vi_webp/PkUZyemHtKk/maxresdefault.webp"
      }
    }
  ]

  self.video = document.getElementById('video')
  self.source_mp4 = document.getElementById('source_mp4')
  self.source_ogv = document.getElementById('source_ogv')
  self.source_webm = document.getElementById('source_webm')
  
  self.video.addEventListener "ended", (event) ->
    self.video.classList.add('watched')
    self.$applyAsync()

  self.video.addEventListener "pause", (event) ->
    self.video.classList.add('watched') unless self.video.currentTime > 0
    self.$applyAsync()

  self.video.addEventListener "playing", (event) ->
    self.customStat(null, 'main_video', 'Opened main video')
    self.$applyAsync()

  self.video.addEventListener "click", (event) ->
    self.$applyAsync()

  self.resetVideo = () ->
    self.video.currentTime = 0

  self.skipVideo = () ->
    self.video.pause()
    self.video.currentTime = 0
    self.video.classList.add('watched')

  self.toggleVolume = () ->
    if self.video.muted || self.video.volume == 0.0
      self.video.muted = false
      return self.video.volume = 0.5 
    return self.video.volume = 1.0 if self.video.volume == 0.5
    return self.video.volume = 0.0 if self.video.volume == 1.0

  self.$on 'pauseVideo', (event) ->
    self.video.pause() if !self.video.paused && !self.video.ended
    return

  self.$on 'playVideo', (event) ->
    self.video.play() if self.video.paused && !self.video.ended
    return

  self.$on 'resetLangVideo', (event) ->
    video_played = !self.video.paused && !self.video.ended && self.video.currentTime != 0
    
    self.video.pause() if video_played
    
    save_ended_status = angular.copy(self.video.ended)
    save_paused_status = angular.copy(self.video.paused)
    save_time_status = angular.copy(self.video.currentTime)
    
    self.source_mp4.setAttribute('src', 'assets/video/FA-Tour_SoMe-Trailer_' + root.lang + '.mp4')
    self.source_ogv.setAttribute('src', 'assets/video/FA-Tour_SoMe-Trailer_' + root.lang + '.ogv')
    self.source_webm.setAttribute('src', 'assets/video/FA-Tour_SoMe-Trailer_' + root.lang + '.webm')

    if save_paused_status && !save_ended_status && save_time_status != 0
      self.video.load()
      self.video.play() 

    return

  self.$on '$destroy', ->
    self.video?.pause()